import TyPrompt from './TyPrompt.vue'
export default TyPrompt



// WEBPACK FOOTER //
// ./src/components/ty-prompt/index.js